import type { ApiClient } from '../../api/client';
import { ToolBrowserGrants } from './Grants';

// The scoped client closes the entire workspace on a real authority denial.
// Local lease expiry already clears every form/key; it must not renew SSO.
const noRenewal = async () => undefined;

export default function OriginalTokenGrants({ apiClient }: { apiClient: ApiClient }) {
  return <div className="stack token-settings">
    <div className="card token-settings__hero">
      <div className="card-header"><div><h2>API Tokens</h2>
        <p className="status">Token and credential governance are unavailable under the originating tool token.</p>
      </div></div>
      <p>Only separately delegated execution grants for the exact originating token can be managed here. No token inventory, credential value, approval or rotation control is loaded.</p>
    </div>
    {apiClient.browserGrantManagement === true
      ? <ToolBrowserGrants apiClient={apiClient} target={{ kind: 'token' }} onExpired={noRenewal} />
      : <div className="card" role="status">No current execution-grant delegation.</div>}
  </div>;
}
